<template>
  <div>
    <div
      :class="['side-panel', 'side-panel-with-curtain', 'absolute end-0 start-auto']"
      @mousedown.self="confirmResetSharePanel"
      @touchstart.self="confirmResetSharePanel"
    >
      <surface-panel-share-subpanel-main :class="['shadow-elevation-3']" />
      <surface-panel-share-subpanel-privacy
        v-if="isWallAccessSettingsFetched && activePanel === ShareSubpanel.Privacy"
        :class="['shadow-elevation-3']"
      />
      <surface-panel-share-subpanel-members
        v-if="isWallAccessSettingsFetched && activePanel === ShareSubpanel.Members"
        :class="['shadow-elevation-3']"
      />
      <surface-panel-share-subpanel-embed v-if="activePanel === ShareSubpanel.Embed" :class="['shadow-elevation-3']" />
      <surface-panel-share-subpanel-lti v-if="activePanel === ShareSubpanel.Lti" :class="['shadow-elevation-3']" />
    </div>
    <surface-panel-share-modal-qr-code-old v-if="isQrModalOpen" />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import SurfacePanelShareModalQrCodeOld from 'vuecomponents/surface_panel_share_modal_qr_code_old'
import SurfacePanelShareSubpanelEmbed from 'vuecomponents/surface_panel_share_subpanel_embed'
import SurfacePanelShareSubpanelLti from 'vuecomponents/surface_panel_share_subpanel_lti'
import SurfacePanelShareSubpanelMain from 'vuecomponents/surface_panel_share_subpanel_main'
import SurfacePanelShareSubpanelMembers from 'vuecomponents/surface_panel_share_subpanel_members'
import SurfacePanelShareSubpanelPrivacy from 'vuecomponents/surface_panel_share_subpanel_privacy'
import { mapActions, mapGetters } from 'vuex'
import { ShareSubpanel } from 'vuexstore/modules/share'

export default {
  components: {
    SurfacePanelShareSubpanelMain,
    SurfacePanelShareSubpanelPrivacy,
    SurfacePanelShareSubpanelMembers,
    SurfacePanelShareSubpanelEmbed,
    SurfacePanelShareSubpanelLti,
    SurfacePanelShareModalQrCodeOld,
  },
  data() {
    return { ShareSubpanel }
  },
  computed: {
    ...mapGetters(['canIAdminister']),
    ...mapGetters('share', ['activePanel', 'isQrModalOpen']),
    ...mapGetters('wallAccessSettings', ['isWallAccessSettingsFetched']),
  },
  beforeMount() {
    // logic to fetch privacy policy here and in surface_panel_settings_section_content_filtering should be the same
    if (this.canIAdminister) {
      this.fetchWallPrivacyOptions()
      this.fetchWallAccessSettings()
    }
  },
  methods: {
    ...mapActions('share', ['confirmResetSharePanel']),
    ...mapActions('wallAccessSettings', ['fetchWallAccessSettings']),
    ...mapActions(['fetchWallPrivacyOptions']),
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';

:deep(.readable) {
  background-color: $material-light-blue-100;
}
:deep(.editable) {
  background-color: $material-amber-100;
}
:deep(.writable) {
  background-color: $material-green-100;
}
:deep(.adminable) {
  background-color: $material-red-100;
}
</style>
